import { Navigation, Route } from '@ydegouvello/ui';
import { SessionsRepository } from 'repositories/sessions.repository';

export class LogoutRoute extends Route {
  private static _instance: LogoutRoute | undefined = undefined;

  private constructor(
    location: string,
    readonly sessionsRepository: SessionsRepository,
    readonly navigation: Navigation,
  ) {
    super(location);
  }

  static getInstance(
    location: string = '/logout',
    sessionsRepository: SessionsRepository = SessionsRepository.getInstance(),
    navigation: Navigation = Navigation.getInstance(),
  ): LogoutRoute {
    this._instance ??= new this(location, sessionsRepository, navigation);
    return this._instance;
  }

  override async execute(): Promise<true> {
    await this.sessionsRepository.logout();
    this.navigation.redirect('/');
    return true;
  }
}
